import { Box, Typography } from "@mui/material";
import { Warning as WarnIcon, CheckCircle as GoodIcon } from "@mui/icons-material";
import { t } from "../dashboard/coach/coachTokens";
import { getHealthFlags } from "./foodDictionaryHealthFlags";

const TONE = {
  warn: { bg: t.redLight, color: t.redText, border: "rgba(224,62,62,.25)", Icon: WarnIcon },
  good: { bg: t.greenLight, color: t.greenText, border: "rgba(1,187,167,.25)", Icon: GoodIcon },
};

/** Colored nutrition flags (warnings + positives) computed from the per-100g values. */
const HealthFlagChips = ({ food }) => {
  const flags = getHealthFlags(food);
  if (!flags.length) return null;

  return (
    <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap" }}>
      {flags.map((f) => {
        const tone = TONE[f.tone] || TONE.good;
        const Icon = tone.Icon;
        return (
          <Box key={f.key} sx={{
            display: "inline-flex", alignItems: "center", gap: "4px",
            background: tone.bg, color: tone.color, border: `1px solid ${tone.border}`,
            borderRadius: "20px", px: "10px", py: "3px",
          }}>
            <Icon sx={{ fontSize: 14 }} />
            <Typography sx={{ fontSize: "12px", fontWeight: 600, lineHeight: 1.2 }}>{f.label}</Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default HealthFlagChips;
